const getTermsState = (state) => state && state.terms ? state.terms : {};
export const status = (state) => getTermsState(state).status;
export const currentDocument = (state) => getTermsState(state).currentDocument;
export const accepting = (state) => getTermsState(state).accepting;
export const error = (state) => getTermsState(state).error;
